class NotificationSoundService {
    private audioCtx: any = null;

    public initAudio() {
        if (!this.audioCtx && typeof window !== 'undefined') {
            const AudioContextClass = (window as any).AudioContext || (window as any).webkitAudioContext;
            if (AudioContextClass) {
                this.audioCtx = new AudioContextClass();
            }
        }
        if (this.audioCtx && this.audioCtx.state === 'suspended') {
            this.audioCtx.resume();
        }
    }

    public playChime() {
        try {
            this.initAudio();
            if (!this.audioCtx) return;

            const now = this.audioCtx.currentTime;

            // Tone 1: 587.33 Hz (D5)
            const osc1 = this.audioCtx.createOscillator();
            const gain1 = this.audioCtx.createGain();
            osc1.type = 'sine';
            osc1.frequency.setValueAtTime(587.33, now);
            gain1.gain.setValueAtTime(0.18, now);
            gain1.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
            osc1.connect(gain1);
            gain1.connect(this.audioCtx.destination);
            osc1.start(now);
            osc1.stop(now + 0.35);

            // Tone 2: 880 Hz (A5)
            const osc2 = this.audioCtx.createOscillator();
            const gain2 = this.audioCtx.createGain();
            osc2.type = 'sine';
            osc2.frequency.setValueAtTime(880, now + 0.12);
            gain2.gain.setValueAtTime(0.22, now + 0.12);
            gain2.gain.exponentialRampToValueAtTime(0.0001, now + 0.6);
            osc2.connect(gain2);
            gain2.connect(this.audioCtx.destination);
            osc2.start(now + 0.12);
            osc2.stop(now + 0.6);
        } catch (e) {
            // Ignore audio context error
        }
    }

    public async requestBrowserPermission(): Promise<string> {
        if (typeof window === 'undefined' || !('Notification' in window)) {
            return 'denied';
        }
        if (Notification.permission === 'granted') {
            return 'granted';
        }
        try {
            return await Notification.requestPermission();
        } catch (e) {
            return Notification.permission;
        }
    }

    public get hasBrowserPermission(): boolean {
        return typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted';
    }

    public showBrowserNotification(title: string, options?: NotificationOptions, onClick?: () => void) {
        if (typeof window === 'undefined' || !('Notification' in window)) return;
        if (Notification.permission !== 'granted') return;

        try {
            const notif = new Notification(title, Object.assign({
                icon: '/favicon.ico',
            }, options || {}));
            notif.onclick = () => {
                window.focus();
                if (onClick) {
                    try {
                        onClick();
                    } catch (e) {}
                }
                notif.close();
            };
            setTimeout(() => {
                try {
                    notif.close();
                } catch (e) {}
            }, 6000);
        } catch (e) {
            // Ignore notification error
        }
    }
}

export const notificationSound = new NotificationSoundService();
export default notificationSound;
